import { EnumZboTypPripadu } from '../api';
export const enumZboTypPripadu = Object.keys(EnumZboTypPripadu);
export const getEnumZboTypPripaduKratkyCaption = (typ) => {
    switch (typ) {
        case EnumZboTypPripadu.ZUK:
            return 'ZUK';
        case EnumZboTypPripadu.SMLOUVA:
            return 'SMLOUVA';
        case EnumZboTypPripadu.OPP:
            return 'OPP';
        case EnumZboTypPripadu.ZADOST_PP:
            return 'ŽÁDOST';
        case EnumZboTypPripadu.MIPO:
            return 'MIPO';
        default:
            return `_${typ}`;
    }
};
export const getEnumZboTypPripaduKratkyItems = () => {
    return enumZboTypPripadu.map(t => ({ id: t, name: getEnumZboTypPripaduKratkyCaption(t) })).sort((a, b) => a.name.localeCompare(b.name));
};
//# sourceMappingURL=ZboTypPripaduCaption.js.map